import {
  people01,
  people02,
  people03,
  facebook,
  instagram,
  linkedin,
  twitter,
  airbnb,
  binance,
  coinbase,
  dropbox,
  send,
  shield,
  star,
} from "../assets";

export const navLinks = [
  {
    id: "descarga",
    title: "Descarga",
    link: "https://drive.google.com/file/d/1lAZaPkd6Xs3NgyW9VAiiEPBpFn9J9KUR/view?usp=sharing",
  },
  {
    id: "admin",
    title: "Admin Panel",
    link: "https://job-match-admin.up.railway.app/",
  },
];

export const features = [
  {
    id: "feature-1",
    icon: star,
    title: "Regístrate",
    content:
      "Una vez creado tu perfil como trabajador podrás ver ofertas de trabajo y postular a ellas. Si eres empresa, podrás crear ofertas de trabajo.",
  },
  {
    id: "feature-2",
    icon: shield,
    title: "Haz match",
    content:
      "Puedes deslizar sobre el perfil que te gusta a la derecha o si no te gusta, a la izquierda.",
  },
  {
    id: "feature-3",
    icon: send,
    title: "Chatea con tu nuevo match",
    content:
      "Una vez existe un match, se abre un nuevo chat entre ambos usuarios.",
  },
];

export const feedback = [
  {
    id: "feedback-1",
    content:
      "Job Match me ayudó a encontrar un trabajo en el área que me gusta. ¡Gracias!",
    name: "Jessica Rodriguez",
    title: "Diseñadora gráfica",
    img: people01,
  },
  {
    id: "feedback-2",
    content:
      "Con Job Match podemos encontrar nuevos candidatos que se ajusten a nuestro perfil.",
    name: "Luis Perez",
    title: "Empresario",
    img: people02,
  },
  {
    id: "feedback-3",
    content:
      "Gracias a Job Match he encontrado un nuevo trabajo en remoto en USA.",
    name: "Alvaro Garcia",
    title: "Frontend Developer",
    img: people03,
  },
];

export const stats = [
  {
    id: "stats-1",
    title: "Usuarios activos",
    value: "3800",
    prefix: "",
    suffix: "+",
  },
  {
    id: "stats-2",
    title: "Personas contratadas",
    value: "468",
    prefix: "",
    suffix: "+",
  },
  {
    id: "stats-3",
    title: "Puestos disponibles",
    value: "1980",
    prefix: "",
    suffix: "+",
  },
];

export const footerLinks = [
  {
    title: "Recursos",
    links: [
      {
        name: "Como funciona",
        link: "https://youtu.be/21jMa7UFzjw",
      },
      {
        name: "Descarga",
        link: "https://drive.google.com/file/d/1lAZaPkd6Xs3NgyW9VAiiEPBpFn9J9KUR/view?usp=sharing",
      },
    ],
  },
  {
    title: "Comunidad",
    links: [
      {
        name: "Sugerencias",
        link: "#",
      },
      {
        name: "Reporta un problema",
        link: "#",
      },
    ],
  },
  {
    title: "Contacto",
    links: [
      {
        name: "Jhazmín Huamán Cruzado",
        link: "#",
      },
      {
        name: "Jhuliño Tafur Valdivia",
        link: "#",
      },
      {
        name: "Jordan Fernández Herrera",
        link: "#",
      },
    ],
  },
];

export const socialMedia = [
  {
    id: "social-media-1",
    icon: instagram,
    link: "https://www.instagram.com/",
  },
  {
    id: "social-media-2",
    icon: facebook,
    link: "https://www.facebook.com/",
  },
  {
    id: "social-media-3",
    icon: twitter,
    link: "https://www.twitter.com/",
  },
  {
    id: "social-media-4",
    icon: linkedin,
    link: "https://www.linkedin.com/",
  },
];

export const clients = [
  {
    id: "client-1",
    logo: airbnb,
  },
  {
    id: "client-2",
    logo: binance,
  },
  {
    id: "client-3",
    logo: coinbase,
  },
  {
    id: "client-4",
    logo: dropbox,
  },
];
